import React from 'react';
import { Box, Grid, Typography, Stack } from '@mui/material';
import { PrismicRichText } from '@prismicio/react';
import Container from 'common/components/UI/Container';
import Image from 'next/image';
import {
  StyledGridContainer,
  StyledTitleBox,
  StyledDescriptionBox,
  StyledButtonPrimary,
  StyledButtonSecondary,
  StyledCard,
} from './NewGetStarted.style';
import Link from 'next/link';

const NewGetStartedSection = ({ slice }) => {
  return (
    <Container>
      <StyledGridContainer container>
        <Grid item xs={12} md={6} >
          <Stack>
            <PrismicRichText
              field={slice.primary.title}
              components={{
                paragraph: ({ children }) => (
                  <StyledTitleBox variant="h3">{children}</StyledTitleBox>
                ),
              }}
            />
            <Stack
              spacing={{ xs: 1, md: 2 }}
              sx={{ marginTop: { xs: '24px', md: '37px' } }}
            >
              <StyledDescriptionBox>
                <PrismicRichText
                  field={slice.primary.description}
                  components={{
                    paragraph: ({ children }) => (
                      <Typography variant="body1" paragraph>
                        {children}
                      </Typography>
                    ),
                  }}
                />
              </StyledDescriptionBox>
              <Box
                sx={{
                  display: 'flex',
                  gap: '12px',
                  flexWrap: 'wrap',
                  justifyContent: 'flex-start',
                }}
              >
                <Link href="https://app.swiftask.ai" passHref legacyBehavior>
                  <StyledButtonPrimary
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {slice.primary.ctagetstarted}
                  </StyledButtonPrimary>
                </Link>
                {slice.primary.ctabookdemo && (
                  <Link href="/contact-us">
                    <StyledButtonSecondary>
                      {slice.primary.ctabookdemo}
                    </StyledButtonSecondary>
                  </Link>
                )}
              </Box>
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} md={6}>
          <StyledCard>
            <Image
              src={slice.primary.image.url}
              alt={slice.primary.image.alt || 'Section image'}
              layout="responsive"
              width={600}
              height={400}
              objectFit="cover"
            />
          </StyledCard>
        </Grid>
      </StyledGridContainer>
    </Container>
  );
};

export default NewGetStartedSection;
